export default {"src":"/_next/static/image/public/images/flags/flag_241.df0e9971adcc08c102fc5d497bfe1b34.svg","height":16,"width":24};